import React, { useEffect, ComponentType } from 'react';
import { getSelectedClient } from '../utils/localStorage';
import { appInsights } from './useAppinsight';
appInsights.loadAppInsights();

const withButtonTracking = <P extends object>(WrappedComponent: ComponentType<P>): React.FC<P> => {
    const HOC: React.FC<P> = (props) => {
        useEffect(() => {
            const handleItemClick = (event: Event) => {
                const selectedClient = getSelectedClient();
                const target = event.target as HTMLElement;
                // @ts-ignore  
                const action = target.closest('[data-component]')?.dataset.component || 'Unknown Component';
                const eventData = {
                    name: 'ButtonClick',
                    properties: {
                        application: 'Web office',
                        client: selectedClient.name,
                        action: action,
                    }
                };
                console.log('Sending event data:', eventData);
                appInsights.trackEvent(eventData);
            };

            const attachEventListeners = () => {
                const items = document.querySelectorAll('[data-component]');
                console.log(`Found ${items.length} items with data-component attribute`); // Debug log
                items.forEach(item => {
                    // Ensure we don't attach multiple event listeners to the same item
                    if (!item.getAttribute('data-tracked')) {
                        item.addEventListener('click', handleItemClick);
                        item.addEventListener('mousedown', handleItemClick);
                        item.setAttribute('data-tracked', 'true');
                    }
                });
            };

            attachEventListeners();

            const observer = new MutationObserver(() => attachEventListeners());
            observer.observe(document.body, { childList: true, subtree: true });

            return () => {
                observer.disconnect();
                const items = document.querySelectorAll('[data-component]');
                items.forEach(item => {
                    item.removeEventListener('click', handleItemClick);
                    item.removeEventListener('mousedown', handleItemClick);
                });
            };
        }, []);

        return <WrappedComponent {...props} />;
    };

    return HOC;
};

export default withButtonTracking;